import { InferOutput, boolean, object, string } from "valibot"

import { BaseApiService, KyOptions } from "@finq/app-base/composables/services/api.service"

export interface JoinPensionRecommendationsParams {
  token: string
  cardMask: string
  cardExp: string
}

const joinPensionRecommendationsResponseSchema = object({
  success: boolean(),
  transactionId: string(),
})

export type JoinPensionRecommendationsResponse = InferOutput<typeof joinPensionRecommendationsResponseSchema>

class KycPensionServiceRaw extends BaseApiService {
  joinPensionRecommendations = async (data: JoinPensionRecommendationsParams, config: KyOptions = {}) => {
    return this.instance
      .post(`/pensions/portfolio/recommendations/join`, data, config)
      .then(this.getData)
      .then((res) => this.parse(res, joinPensionRecommendationsResponseSchema))
  }
}

/** Exporting a singleton object to entire app */
export const KycPensionService = new KycPensionServiceRaw()
